import {
  ActivatePayoutAccountRequest,
  CreatePayoutAccountRequest,
  ListPayoutAccountsResponse,
} from '@/types/api/payout-account';
import { authenticatedClient } from '@/utils/shared/axios';

export default {
  list: async (): Promise<ListPayoutAccountsResponse> => {
    const response = await authenticatedClient.get<ListPayoutAccountsResponse>(`/payments/payout-accounts`);
    return response.data;
  },

  activate: async ({ payoutAccountId, groupId }: ActivatePayoutAccountRequest) => {
    await authenticatedClient.post(`/payments/payout-accounts/${payoutAccountId}/activate?groupId=${groupId}`);
  },

  create: async (data: CreatePayoutAccountRequest) => {
    await authenticatedClient.post(`/payments/payout-accounts`, data);
  },
};
